/**
 * `useTheme` hook accessing the current theme.
 */
import * as React from "react"
import { ThemeContext } from "@oui/system"

const useTheme = () => React.useContext(ThemeContext)

export default useTheme
